import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-book-brown shadow-book sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" data-discover="true" className="flex items-center space-x-2" itemScope itemType="https://schema.org/Organization">
            <img src="/images/favicon.webp" alt="Brit Ember Logo" className="h-8 w-8" itemProp="logo" />
            <span className="text-2xl font-bold text-book-cream" itemProp="name">Brit Ember</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" data-discover="true" className="text-book-cream hover:text-book-gold transition-colors duration-200 font-medium">
              Home
            </Link>
            <Link to="/guides" data-discover="true" className="text-book-cream hover:text-book-gold transition-colors duration-200 font-medium">
              Guides
            </Link>
            <Link to="/news" data-discover="true" className="text-book-cream hover:text-book-gold transition-colors duration-200 font-medium">
              News
            </Link>
            <Link to="/reviews" data-discover="true" className="text-book-cream hover:text-book-gold transition-colors duration-200 font-medium">
              Reviews
            </Link>
            <Link to="/slots" data-discover="true" className="text-book-cream hover:text-book-gold transition-colors duration-200 font-medium">
              Slots
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={toggleMenu}
            className="md:hidden text-book-cream hover:text-book-gold transition-colors duration-200"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-book-brown-light">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                data-discover="true"
                className="text-book-cream hover:text-book-gold transition-colors duration-200 font-medium"
                onClick={toggleMenu}
              >
                Home
              </Link>
              <Link
                to="/guides"
                data-discover="true"
                className="text-book-cream hover:text-book-gold transition-colors duration-200 font-medium"
                onClick={toggleMenu}
              >
                Guides
              </Link>
              <Link
                to="/news"
                data-discover="true"
                className="text-book-cream hover:text-book-gold transition-colors duration-200 font-medium"
                onClick={toggleMenu}
              >
                News
              </Link>
              <Link
                to="/reviews"
                data-discover="true"
                className="text-book-cream hover:text-book-gold transition-colors duration-200 font-medium"
                onClick={toggleMenu}
              >
                Reviews
              </Link>
              <Link
                to="/slots"
                data-discover="true"
                className="text-book-cream hover:text-book-gold transition-colors duration-200 font-medium"
                onClick={toggleMenu}
              >
                Slots
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
